<!-- Faux border-top fixes https://kaligo.atlassian.net/browse/BNZ-356 fastest. There is a weird
interaction between zooming. -->
<div class="faux-border"></div>
<nav
  class="relative m-0 hidden h-[55px] items-center gap-[36px] px-10 py-0 lg:flex">
  <a
    [routerLink]="bnzNavLinks.home.route"
    role="menuitem"
    class="button rewards typo-emphasis-3-desktop focus-link flex h-full flex-shrink-0 items-end items-center gap-[10px]">
    <img [src]="logoImage" alt="" class="h-full w-[100px]" />
    <span class=""> {{ 'wl.bnz.header.home' | translate }} </span>
  </a>

  <ng-container *ngIf="!(isFlybuys$ | async)">
    <a
      [routerLink]="bnzNavLinks.offers.route"
      role="menuitem"
      class="button main typo-text-desktop focus-link block flex-shrink-0"
      [class.active]="isActivatedOffersMenuItem()">
      {{ offerText | translate }}
    </a>

    <div class="flex-shrink-0">
      <button
        #redemptionButton
        class="button-reset main typo-text-desktop focus-link flex items-center gap-2"
        id="redemption-button"
        type="button"
        (click)="toggleRedemption()"
        (rdClickOutside)="closeRedemption()"
        aria-haspopup="menu"
        [class.active]="isActivatedRedeemMenuItem()">
        <ng-container *ngIf="loyaltyCurrency$ | async as loyaltyCurrency">
          {{
            'wl.bnz.header.redeem'
              | translate: { loyaltyCurrency: loyaltyCurrency.name }
          }}
          <rd-shared-icon
            [ngClass]="{
              'rotate-180': redemptionExpanded
            }"
            class="chevron"
            [iconSymbol]="'icon-chevron-down'"
            [iconTheme]="'primary'"></rd-shared-icon>
        </ng-container>
      </button>
      <ul
        class="menu-content border-radius button absolute top-[50px] m-0 flex w-[216px] flex-col gap-[2px]"
        aria-describedby="redemption-button"
        role="menu"
        [class.expanded]="!redemptionExpanded">
        <ng-container
          *ngFor="let link of bnzNavLinks.redemptions; let i = index">
          <li>
            <a
              *ngIf="isExternalNavLink(link); else internal"
              class="focus-link block px-[20px] py-[12px]"
              role="menuitem"
              [href]="link.route"
              myRedemptionLink
              [id]="'redeem-' + i"
              [class.active]="isActivatedChildMenuItem(link.route)">
              {{ link.translationKey | translate }}
            </a>
            <ng-template #internal>
              <a
                class="focus-link block px-[20px] py-[12px]"
                role="menuitem"
                [routerLink]="link.route"
                myRedemptionLink
                [id]="'redeem-' + i"
                [class.active]="isActivatedChildMenuItem(link.route)">
                {{ link.translationKey | translate }}
              </a>
            </ng-template>
          </li>
        </ng-container>
        <li>
          <a
            *ngIf="bnzNavLinks.flybuysRedemptionLink$ | async as link"
            class="focus-link block px-[20px] py-[12px]"
            role="menuitem"
            [routerLink]="link.route"
            myRedemptionLink
            [id]="'redeem-' + bnzNavLinks.redemptions.length"
            [class.active]="isFlybuysLinkActive">
            {{ link.translationKey | translate }}
          </a>
        </li>
      </ul>
    </div>
    <div
      *ifLoggedIn
      class="flex h-full w-full flex-grow items-center justify-end gap-4">
      <div *ngIf="pointsInformation$ | async as pointsInformation">
        <a
          routerLink="/points_activity"
          class="focus-link flex flex-row items-center gap-x-1"
          role="menuitem">
          <rd-shared-icon
            *ngIf="isStarIconEnabled"
            iconSymbol="icon-bankwide-rewards-star"
            iconTheme="primary"
            class="block h-6 w-6">
          </rd-shared-icon>

          <span class="typo-emphasis-1-desktop">
            {{ pointsInformation[0].pointsBalance | localizePointsNumber }}
          </span>
          <span class="typo-text-desktop-2">
            {{ pointsInformation[1].name }}
          </span>
        </a>
      </div>
      <button
        id="myAccount-button"
        class="button-reset focus-link inline-flex items-center gap-2"
        aria-label="my account"
        aria-haspopup="menu"
        (click)="toggleMyAccount()"
        (rdClickOutside)="closeMyAccount()"
        #myAccountButton>
        <rd-shared-icon
          class="user"
          [iconSymbol]="'icon-user'"
          [iconTheme]="'primary'"></rd-shared-icon>
        <rd-shared-icon
          [ngClass]="{
            'rotate-180': myAccountExpanded
          }"
          class="chevron"
          [iconSymbol]="'icon-chevron-down'"
          [iconTheme]="'primary'"></rd-shared-icon>
      </button>
      <ul
        class="menu-content border-radius button absolute top-[50px] m-0 flex min-w-[220px] flex-col gap-[2px]"
        aria-describedby="myAccount-button"
        role="menu"
        *ngIf="bnzNavLinks.myAccount$ | async as myAccount"
        [class.expanded]="!myAccountExpanded">
        <li *ngFor="let link of myAccount; let i = index">
          <a
            *ngIf="isExternalNavLink(link); else internal"
            class="focus-link block px-[20px] py-[12px]"
            role="menuitem"
            [href]="link.route"
            [id]="'myAccount-' + i"
            myAccountLink
            [class.active]="isActivatedChildMenuItem(link.route)">
            {{ link.translationKey | translate }}
          </a>
          <ng-template #internal>
            <a
              class="focus-link block px-[20px] py-[12px]"
              role="menuitem"
              [routerLink]="link.route"
              [id]="'myAccount-' + i"
              myAccountLink
              [class.active]="isActivatedChildMenuItem(link.route)">
              {{ link.translationKey | translate }}
            </a>
          </ng-template>
        </li>
        <li>
          <button
            type="button"
            class="button-reset typo-text-desktop focus-link flex w-full items-center gap-[10px] px-[20px] py-[12px]"
            myAccountLink
            role="menuitem"
            (click)="redirectToLogout()"
            [id]="'myAccount-' + myAccount.length">
            <rd-shared-icon
              class="logout"
              [iconSymbol]="'icon-logout'"
              [iconTheme]="'primary'"></rd-shared-icon>
            <span>{{ 'wl.bnz.header.logout' | translate }}</span>
          </button>
        </li>
      </ul>
    </div>
    <div
      *ifNotLoggedIn
      class="flex h-[30px] w-full flex-grow items-center justify-end gap-4">
      <rd-shared-button
        role="menuitem"
        buttonClass="action-button"
        buttonTheme="secondary"
        buttonText="Sign up"
        [redirectURL]="
          'https://www.bnz.co.nz/personal-banking/credit-cards/bnz-advantage'
        "
        [isTargetBlank]="true">
      </rd-shared-button>
      <rd-shared-button
        role="menuitem"
        buttonClass="action-button"
        buttonTheme="primary"
        buttonText="Login"
        (clickFn)="openLoginModal()">
      </rd-shared-button>
    </div>
  </ng-container>
</nav>

<bnz-mobile-header class="lg:hidden"></bnz-mobile-header>
